import { fromJS } from 'immutable'
import {
  setTermsData,
  setTermsProcessing,
  setTermsError,
  GET_TERMS_DATA,
} from './actions'
import {
  getTerms,
} from '..'

const log = console

async function getTermsDataHandler ({ store, action }) {
  const { config, auth } = store.getState()

  try {
    store.dispatch(setTermsProcessing(true))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      value: action.payload,
    }
    const data = await getTerms(options)
    store.dispatch(setTermsData(
      fromJS(data),
    ))
  } catch (error) {
    log.error(error, 'Error getting terms data for autosuggest.')
    store.dispatch(setTermsError(
      error,
    ))
  }
}

export default (store) => (next) => (action) => {
  const { type } = action
  switch (type) {
    case GET_TERMS_DATA:
      getTermsDataHandler({ store, action })
      break
    default:
      break
  }
  next(action)
}
